'use strict';

define(['app', '$window', 'enhancedEcom', 'siteObj'], function (app, window, enhancedEcom, siteObj) {

  var athenaProductPage = function athenaProductPage() {
    var component = {};

    var _config = {
      enhancedEcomUpdate: 'enhancedEcom/update',
      externalSku: '.externalSku',
      brandLogo: '.athenaProductPage_productBrandLogo',
      priceAmount: '.productPrice_priceAmount',
      productPageStockAvailabilityComp: '.productPageStockAvailability'
    };

    var _attrib = {
      homeDelivery: 'data-home-delivery',
      inStock: 'data-in-stock',
      inStockWarehouse: 'data-in-stock-warehouse',
      clickAndCollect: 'data-click-and-collect',
      checkStock: 'data-check-stock',
      noCheckStock: 'data-no-check-stock',
      orderInStore: 'data-order-in-store',
      externalSku: 'data-external-sku',
      brand: 'data-product-brand',
      range: 'data-product-range',
      hasEnhancedEcommerce: 'data-enhanced-ecom',
      category: 'data-product-category',
      collectionType: 'data-product-collection-type'
    };

    var _init = function _init(element) {
      component.element = element;
      component.hasEnhancedEcommerce = component.element.hasAttribute(component.attrib.hasEnhancedEcommerce);
      if (component.hasEnhancedEcommerce) {
        app.subscribe(component.config.enhancedEcomUpdate, component.enhancedEcomUpdate);
        component.enhancedEcomUpdate();
      }
      if (siteObj.config.useGa4EnhancedEcom === true) {
        ga4PageView();
      }
      return component;
    };

    var ga4PageView = function ga4PageView() {
      var productCategory = component.element.getAttribute('data-product-category');
      var price = siteObj.productPrice.split(';')[1] || siteObj.productPrice;
      var savingAmountClass = document.querySelector('.productPrice_savingAmount');
      var savingAmount = '';
      if (savingAmountClass) {
        savingAmount = savingAmountClass.getAttribute('data-product-saving');
      }
      var itemsObjectArray = [{
        'item_name': siteObj.productTitle,
        'item_id': siteObj.productID,
        'price': price,
        'item_brand': siteObj.productBrand,
        'item_category': productCategory,
        'discount': savingAmount
      }];

      app.publish('ga4tracking/record', 'ecom_event', 'view_item', siteObj.currencyType, itemsObjectArray);
    };

    var _enhancedEcomUpdate = function _enhancedEcomUpdate() {
      var stockAvailability = component.element.querySelector(component.config.productPageStockAvailabilityComp);

      var homeDeliveryAvailable = '';
      var inStock = '';
      var inStockWarehouse = '';
      var clickAndCollect = '';
      var checkStock = '';
      var noCheckStock = '';
      var collectionType = '';
      var category = '';

      if (stockAvailability) {
        homeDeliveryAvailable = stockAvailability.getAttribute(component.attrib.homeDelivery);
        inStock = stockAvailability.getAttribute(component.attrib.inStock);
        inStockWarehouse = stockAvailability.getAttribute(component.attrib.inStockWarehouse);
        clickAndCollect = stockAvailability.getAttribute(component.attrib.clickAndCollect);
        checkStock = stockAvailability.getAttribute(component.attrib.checkStock);
        noCheckStock = stockAvailability.getAttribute(component.attrib.noCheckStock);
        collectionType = stockAvailability.getAttribute(component.attrib.collectionType);
        category = stockAvailability.getAttribute(component.attrib.category);
      }

      var sku = siteObj.productID;
      var externalSku = component.element.querySelector(component.config.externalSku);
      if (externalSku) {
        sku = externalSku.getAttribute(component.attrib.externalSku);
      }
      var productName = siteObj.productTitle;
      var productPrice = component.element.querySelector(component.config.priceAmount).innerHTML;
      var productBrandSelector = component.element.querySelector(component.config.brandLogo);
      var productBrand = productBrandSelector.getAttribute(component.attrib.brand);

      var productRange = '';

      if (productBrand === null || productBrand === '') {
        productRange = component.element.querySelector('[data-information-component="range"] div').textContent;

        enhancedEcom.productView(productName, sku, productPrice, productRange, inStock, inStockWarehouse, homeDeliveryAvailable, clickAndCollect, checkStock, noCheckStock, collectionType, category, productRange);
      } else {
        enhancedEcom.productView(productName, sku, productPrice, productBrand, inStock, inStockWarehouse, homeDeliveryAvailable, clickAndCollect, checkStock, noCheckStock, collectionType, category, productRange);
      }
    };

    component.config = _config;
    component.attrib = _attrib;
    component.init = _init;
    component.enhancedEcomUpdate = _enhancedEcomUpdate;
    return component;
  };

  return athenaProductPage;
});
//# sourceMappingURL=athenaProductPage.js.map
